var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.10999 0.5 3.23996 0.76392 2.49994 1.25839C1.75991 1.75285 1.18314 2.45566 0.842544 3.27792C0.50195 4.10019 0.412835 5.00499 0.586468 5.87791C0.760102 6.75082 1.18868 7.55264 1.81802 8.18198C2.44736 8.81132 3.24918 9.2399 4.1221 9.41353C4.99501 9.58717 5.89981 9.49805 6.72208 9.15746C7.54434 8.81686 8.24715 8.24009 8.74161 7.50006C9.23608 6.76004 9.5 5.89002 9.5 5C9.5 3.80653 9.02589 2.66193 8.18198 1.81802C7.33807 0.974106 6.19348 0.5 5 0.5ZM5 2.42857C5.09536 2.42857 5.18858 2.45685 5.26787 2.50983C5.34715 2.56281 5.40895 2.63811 5.44544 2.72621C5.48194 2.81431 5.49148 2.91125 5.47288 3.00478C5.45428 3.0983 5.40836 3.18421 5.34093 3.25164C5.2735 3.31907 5.18759 3.36499 5.09406 3.38359C5.00054 3.4022 4.90359 3.39265 4.81549 3.35616C4.72739 3.31966 4.65209 3.25787 4.59911 3.17858C4.54614 3.09929 4.51786 3.00607 4.51786 2.91071C4.51786 2.78284 4.56866 2.66021 4.65907 2.56979C4.74949 2.47937 4.87213 2.42857 5 2.42857ZM6.28572 7.61161H3.71429V6.88839H4.63839V5.04018H4.03572V4.31696H5.36161V6.88839H6.28572V7.61161Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.59c9cbf45d0327630530dba6bdd82c18.svg";
export { ForwardRef as ReactComponent };